'use strict';

import ajax from '../../ajax';
import tooltip from '../../tooltip';
import util from '../../util';

export default function () {
	var $addToCart = $('.add-to-cart'),
		$addAllToCart = $('#add-all-to-cart'),
		$productSetList = $('#product-set-list');

	var updateAddToCartButtons = function () {
		if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
			$addAllToCart.attr('disabled', 'disabled');
			// product set does not have an add-to-cart button, but product bundle does
			$addToCart.attr('disabled', 'disabled');
		} else {
			$addAllToCart.removeAttr('disabled');
			$addToCart.removeAttr('disabled');
		}
	};

	if ($productSetList.length > 0) {
		updateAddToCartButtons();
	}
	// click on swatch for product set
	$productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
		e.preventDefault();
		var url = Urls.getSetItem + this.search;
		var $container = $(this).closest('.product-set-item');
		var qty = $container.find('form input[name="Quantity"]').first().val();

		ajax.load({
			url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
			target: $container,
			callback: function () {
				updateAddToCartButtons();
				tooltip.init();
			}
		});
	});

	$productSetList.on('change', '.product-set-item .variation-select', function (e) {
		e.preventDefault();

		var $selectedVariantOption = $(this).find("option:selected");
		if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
			return;
		}

		var url = Urls.getSetItem + "?" + util.getQueryString($selectedVariantOption.val());
		var $container = $(this).closest('.product-set-item');
		var qty = $container.find('select[name="Quantity"] option:selected').val();

		ajax.load({
			url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
			target: $container,
			callback: function () {
				updateAddToCartButtons();
				tooltip.init();
			}
		});
	});

	$(document).on('click', '#bv_components_histogram', function (e) {
		if($('.bv_modal_component_container').length > 0) {
			e.preventDefault();
			e.stopPropagation();
			
				if($("#reviews").css('display') == 'none' || $("#reviews").css('display') != 'block'){
					$('[aria-controls$="reviews"]').trigger('click');
				}

			$('html, body').stop(true, true).animate({
				scrollTop: parseFloat($("#reviews").offset().top) - 100 + 'px'
			}, 1000);
		}
	});
	
	$(document).on('click', '.product-details-wrapper .pdp-accordion__header', function (e) {
		e.preventDefault();
		e.stopPropagation();
	});
};
